import {Injectable} from "@angular/core";
import {BaseApi} from "./baseService";
import {ConfigService} from "./configService";
import {Http, RequestOptions} from "@angular/http";
import {BaseResponse} from "../objects/common/baseResponse";
/**
 * Created by alex.y on 7/27/2017.
 */
@Injectable()
export class GoogleService extends BaseApi {

    constructor(http: Http, configService: ConfigService) {
        super(http, configService);
    }

    public getGoogleContacts(): Promise<BaseResponse<Array<string>>>{
        return this.get(new RequestOptions({
            url: `google/contacts`
        }));
    }

}



// WEBPACK FOOTER //
// ./app/services/googleService.ts